import { useQuery } from '@tanstack/react-query';

import { api, unwrap, type Schemas } from './api/client.js';

/**
 * Security advisories of the register (SP-D24, GET /advisories): the active advisories and, for
 * every site of the account, where it stands with each of them.
 */
export type Advisory = Schemas['Advisory'];
export type AdvisorySite = Schemas['AdvisorySite'];
export type AdvisoryStatus = AdvisorySite['status'];

/** The site is not known to be safe: the banner and the card count these (not clear/checked). */
export const OPEN_STATUSES: readonly AdvisoryStatus[] = ['affected', 'unknown', 'pending'];

/** How the software is named to the customer. */
export const SOFTWARE_NAMES: Record<Advisory['software'], string> = { php: 'PHP' };

export function useAdvisories() {
  return useQuery({
    queryKey: ['advisories'],
    queryFn: () => unwrap(api.GET('/advisories')),
    // The register changes with a release, a site's state with a check: once a minute is enough.
    staleTime: 60_000,
  });
}
